import { render } from "./BarSpacer.vue?vue&type=template&id=563ebb40"
const script = {}

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__